

// @ts-nocheck

import Vue from 'vue'
import NPSSVG from './SVGs/NPS.vue'
import CSATSVG from './SVGs/CSAT.vue'
import StarSVG from './SVGs/Star.vue'

export default Vue.extend({
    components: {
        NPSSVG,
        CSATSVG,
        StarSVG
    },
    props: {
        currentSelection: String
    },
    computed: {
        currentContent(): string {
            switch (this.currentSelection) {
                case 'csat':
                    return 'A simple, emotion-based rating method. Respondents choose between 5 smileys to share how they feel.'                    
                case 'nps':
                    return 'Respondents choose how likely they are to recommend you on a scale of 0 - 10. More than two thirds of the Fortune 100 use NPS.'                    
                case 'star':
                    return 'A simple, modern rating method. Respondents choose between 1 - 5 stars.'
                default:
                    return ''
            }            
        }
    }
})

